(() => {
 const section=document.querySelector('.edit-story');
 if(!section || !window.gsap || !window.ScrollTrigger) return;
 gsap.registerPlugin(ScrollTrigger);
 const stage=section.querySelector('.edit-story-stage');
 const scenes=[...section.querySelectorAll('.edit-story-scene')];
 const dots=[...section.querySelectorAll('.edit-story-progress i')];
 const brandHeading=section.querySelector('[data-chapter="store"] h3') || scenes[2]?.querySelector('h3');
 if(brandHeading && !brandHeading.querySelector('.story-brand')){
  brandHeading.setAttribute('aria-label','Make it ALDA.');
  brandHeading.innerHTML='<span class="story-brand-lead">Make it</span> <span class="story-brand" aria-hidden="true"><svg class="story-brand-logo" viewBox="0 0 609.6 138.2" aria-hidden="true"><defs><mask id="story-brand-reveal" maskUnits="userSpaceOnUse" x="0" y="0" width="610" height="139"><g fill="none" stroke="white" stroke-width="43" stroke-linecap="square" stroke-linejoin="round"><path class="story-brand-trace" pathLength="1" d="M20 19H111Q135 19 135 42V119H21V70H132"/><path class="story-brand-trace" pathLength="1" d="M187 20V105Q187 119 204 119H242"/><path class="story-brand-trace" pathLength="1" d="M293 19H402Q424 19 424 41V98Q424 119 402 119H293V70"/><path class="story-brand-trace" pathLength="1" d="M476 19H567Q591 19 591 42V119H477V70H588"/></g></mask></defs><image href="https://static.aldaindia.com/alda-assets/alda-logo.svg" width="609.6" height="138.2" mask="url(#story-brand-reveal)"/></svg></span><span class="story-brand-dot" aria-hidden="true">.</span>';
 }
 // The cards' photographs are lazy, and Safari only starts a lazy image when it is nearly on screen - so on a phone
 // the pinned stage arrived before its pictures (2026-11-04, the owner on an iPhone). All three chapters' images start
 // loading once the section is two screens away, so they are in before the first card animates in.
 const pictures=[...section.querySelectorAll('.edit-story-card img')];
 if('IntersectionObserver' in window){
  const early=new IntersectionObserver(entries=>{
   if(!entries.some(entry=>entry.isIntersecting))return;
   early.disconnect();
   pictures.forEach(img=>{img.loading='eager';});
  },{rootMargin:'200% 0px'});
  early.observe(section);
 }else pictures.forEach(img=>{img.loading='eager';});
 // One chapter's arrival, added to a timeline at `start`: its headline and cards rise in, then the headline's small,
 // literal punctuation of motion (the chop splits, the bite is taken); the ALDA logo comes in with its
 // headline, untraced (2026-11-05, the owner: its trace came so late a reader could reach the next section first). Shared by the pinned
 // stage (desktop) and the stacked chapters (phones).
 function arrive(scene, sceneCards, timeline, start){
  const chop=scene.querySelectorAll('.story-chop-half');
  const bite=scene.querySelector('.story-bite');
  if(chop.length)gsap.set(chop,{x:0,y:0});
  if(bite)gsap.set(bite,{'--bite-size':'0px',x:0,y:0,rotation:0,transformOrigin:'50% 65%'});
  sceneCards.forEach(card=>gsap.set(card,{x:0,y:16,scale:.93,autoAlpha:0}));
  timeline.set(scene,{autoAlpha:1},start)
   .fromTo(scene.querySelector('h3'),{autoAlpha:0,y:14},{autoAlpha:1,y:0,duration:.35},start)
   .to(sceneCards,{x:0,y:0,scale:1,autoAlpha:1,rotation:(i,card)=>parseFloat(card.style.getPropertyValue('--tilt')),duration:.58,stagger:.045,ease:'power3.out'},start);
  // Let the sentence settle before its small, literal punctuation of motion.
  if(chop.length){
   const word=chop[0].parentElement,w=word.offsetWidth,h=word.offsetHeight;
   const a=50-h/w*50,b=50+h/w*50;
   chop[0].style.clipPath=`polygon(0 0,${a}% 0,${b}% 100%,0 100%)`;
   chop[1].style.clipPath=`polygon(${a}% 0,100% 0,100% 100%,${b}% 100%)`;
   timeline.to(chop[0],{x:-1,y:3,duration:.22,ease:'power2.in'},start+.95);
  }
  if(bite){
   const size=parseFloat(getComputedStyle(bite).fontSize)*.15,at=start+.95;
   timeline.to(bite,{'--bite-size':size*.65+'px',x:-2,y:1,rotation:-.6,duration:.11,ease:'power2.out'},at)
    .to(bite,{x:0,y:0,rotation:0,duration:.24,ease:'power2.out'},at+.11)
    .to(bite,{'--bite-size':size+'px',x:-3,y:1,rotation:-.8,duration:.11,ease:'power2.out'},at+.5)
    .to(bite,{x:0,y:0,rotation:0,duration:.35,ease:'power2.out'},at+.61);
  }
 }
 const cards=scenes.map(scene=>[...scene.querySelectorAll('.edit-story-card')]);
 const media=gsap.matchMedia();
 // Desktop: the stage pins and the three chapters take turns as the section scrolls by.
 media.add('(prefers-reduced-motion: no-preference) and (min-width: 701px)',()=>{
  let active=-1, animation;
  gsap.set(scenes,{autoAlpha:0});
  scenes.forEach(scene=>{scene.inert=true;});
  cards.flat().forEach(card=>gsap.set(card,{x:0,y:16,scale:.93,autoAlpha:0}));
  function enter(index){
   if(index===active)return;
   const previous=active;active=index;
   if(animation)animation.kill();
   scenes.forEach((scene,i)=>{if(i!==previous && i!==index)gsap.set(scene,{autoAlpha:0});});
   scenes.forEach((scene,i)=>{scene.inert=i!==index;});
   dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));
   animation=gsap.timeline({defaults:{overwrite:'auto'}}).timeScale(.85);
   if(previous>=0 && previous<scenes.length){
    animation.to(cards[previous],{x:0,y:-12,scale:.93,autoAlpha:0,duration:.42,stagger:.035,ease:'power2.inOut'},0)
     .to(scenes[previous].querySelector('h3'),{autoAlpha:0,y:-12,duration:.2},0)
     .to(scenes[previous],{autoAlpha:0,duration:.01},.61);
   }
   if(index<scenes.length)arrive(scenes[index],cards[index],animation,previous<0?0:.42);
  }
  // Keep the opening chapter visible while the stage scrolls into view.
  // Chapter changes still use the pinned stage's original progress range.
  enter(0);
  const trigger=ScrollTrigger.create({trigger:section,start:'top top',end:'bottom bottom',onUpdate:self=>enter(self.progress<.36?0:self.progress<.73?1:2),onEnter:()=>enter(0),onEnterBack:self=>enter(self.progress<.73?1:2),onLeaveBack:()=>enter(0)});
  if(trigger.isActive)enter(trigger.progress<.36?0:trigger.progress<.73?1:2);
  return()=>{animation?.kill();scenes.forEach(scene=>scene.inert=false);};
 });
 // Phones (2026-11-04, the owner: one swipe flew past the middle chapter and the held screen confused): no pin - the
 // chapters stack and scroll like the rest of the page (homepage-edit.css), and each one arrives as it comes into view
 // with the same motion as on desktop.
 media.add('(prefers-reduced-motion: no-preference) and (max-width: 700px)',()=>{
  const timelines=[];
  scenes.forEach((scene,i)=>{
   scene.inert=false;
   gsap.set(scene.querySelector('h3'),{autoAlpha:0});
   cards[i].forEach(card=>gsap.set(card,{x:0,y:16,scale:.93,autoAlpha:0}));
  });
  const triggers=scenes.map((scene,i)=>ScrollTrigger.create({trigger:scene,start:'top 78%',once:true,onEnter:()=>{
   const timeline=gsap.timeline({defaults:{overwrite:'auto'}}).timeScale(.85);
   arrive(scene,cards[i],timeline,0);
   timelines.push(timeline);
  }}));
  return()=>{triggers.forEach(trigger=>trigger.kill());timelines.forEach(timeline=>timeline.kill());};
 });
})();


